<template>
  <b-modal
    v-model="warningShown"
    :title="'Session timeout'"
    centered
    :size="'sm'"
    no-close-on-backdrop
    header-bg-variant="danger"
    header-text-variant="white"
    hide-footer
    hide-header-close
  >
    <b-row>
      <b-col>
        <p>
          Your online session will expire in
        </p>
        <h1 class="no-margin-top countdown">
          {{ remainingTime }}
        </h1>
        <p class="no-margin-bottom">
          Move mouse to continue working
        </p>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { inactivity } from "../../config/layout";
import { setToken } from "../../helpers/session";
import { formatSecondsToMinutes } from "../../helpers/date";
export default {
  name: "InactivityOverlay",
  data() {
    return {
      inactivitySeconds: 0,
      timerRef: null,
      redirectSeconds: inactivity.redirectSeconds,
      warningSeconds: inactivity.warningSeconds
    };
  },
  mounted() {
    this.checkInitialInactivity();
    this.eventSubscribe();
    this.startSessionTimer();
  },
  methods: {
    eventSubscribe() {
      const resetFunction = e => {
        this.hasActivity(e);
      };
      document.onmousemove = resetFunction;
      document.onkeypress = resetFunction;
    },
    hasActivity() {
      this.startSessionTimer();
    },
    startSessionTimer() {
      if (this.timerRef) {
        clearInterval(this.timerRef);
      }
      this.inactivitySeconds = 0;
      this.inactivityBegin = Math.floor(Date.now() / 1000);
      localStorage.setItem("inactivityBegin", this.inactivityBegin);
      this.timerRef = setInterval(() => {
        this.inactivityBegin = this.readInactivity();
        this.inactivitySeconds =
          Math.floor(Date.now() / 1000) - this.inactivityBegin;
        if (this.inactivitySeconds > this.redirectSeconds) {
          this.logout();
        }
      }, 1000);
    },
    checkInitialInactivity() {
      const inactivityBegin = this.readInactivity();
      const inactivitySeconds =
        Math.floor(Date.now() / 1000) -
        (inactivityBegin ? parseInt(inactivityBegin) : 0);
      if (inactivitySeconds > this.redirectSeconds) {
        this.logout();
      }
    },
    readInactivity() {
      return localStorage.getItem("inactivityBegin");
    },
    logout() {
      setToken("");
      location.reload();
    }
  },
  computed: {
    warningShown: {
      get() {
        return this.inactivitySeconds > this.warningSeconds;
      }
    },
    remainingTime() {
      return formatSecondsToMinutes(
        Math.max(this.redirectSeconds - this.inactivitySeconds, 0)
      );
    }
  }
};
</script>
